// extracted by mini-css-extract-plugin
export var textInput = "_h4-0";